import actionTypes from '../constants/action-types';

const campaignsState = {
  campaigns: null,
  showCreateCampaignModal: false,
  createCampaignInProgress: false,
  link: null,
  showChooseCampaignModal: false,
  showMobileCampaignModal: false,
};

export const campaignsReducer = (state = campaignsState, payload) => {
  switch (payload.type) {
    case actionTypes.HANDLE_SUCCESS_GET_CAMPAIGNS:
      return { ...state, campaigns: payload.data };
    case actionTypes.TOGGLE_CREATE_CAMPAIGN_MODAL:
      return { ...state, showCreateCampaignModal: payload.data.show, link: payload.data.link };
    case actionTypes.CREATE_CAMPAIGN_IN_PROGRESS:
      return { ...state, createCampaignInProgress: payload.data };
    case actionTypes.TOGGLE_CHOOSE_CAMPAIGN_MODAL:
      return { ...state, showChooseCampaignModal: payload.data };
    case actionTypes.TOGGLE_MOBILE_CAMPAIGN_MODAL:
      return { ...state, showMobileCampaignModal: payload.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/main/campaigns/reducers/campaigns-reducer.js